<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="plus" class="add-btn" @click="addBtn">
          新增文件
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:filePath="{ tableRow }">
          <a herf="javascript:;" @click="handleDownload(tableRow.id)">
            <span>{{ tableRow.filePath }}</span>
          </a>
        </template>

        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="是否删除该文档类型?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="文档名称(100个字符以内)">
          <a-input
            :maxLength="100"
            allowClear
            v-decorator="['fileName']"
          ></a-input>
        </a-form-item>
        <a-form-item label="备注(200个字符以内)">
          <a-textarea
            :maxLength="200"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            allowClear
            v-decorator="['remark']"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="选择文件">
          <a-upload
            name="file"
            v-decorator="['filePath']"
            :header="header"
            :remove="handleDownloadRemove"
            :fileList="fList"
            action="/credit/public/folder/file/upload"
            @change="handleChange"
          >
            <a-button @click="changeBtn">
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, remove, add, download } from './api'

export default {
  mixins: [mixin],
  data() {
    return {
      header: { 'Content-Type': 'multipart/form-data' },
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
      fList: [],
      showfilePath: false,
      selectList: [],
      fileList: {},
      file: {},
      fileS: [],
      attach: false,
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 下载文件
    handleDownload(id) {
      download(id)
    },
    // 删除文件
    handleDownloadRemove() {
      this.fList.splice(0, Infinity)
    },
    // 点击选取文件
    changeBtn() {
      this.fileList = {}
    },
    // 新增按钮显示弹框
    addBtn() {
      this.visible = true
      this.fList = []
      this.fileList = {}
    },
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        attach: this.attach,
        fileType: '4',
        ...this.searchForm,
        size: pageSize,
        current,
      }

      getTableData(formData).then(({ data: { records, total } }) => {
        this.tableData = records
        this.pageData.total = total
        this.tableLoading = false
      })
    },
    handleChange(data) {
      const {
        file,
        file: { response },
      } = data
      if (response && response.code === '0000') {
        const { filePath, fileOriginalName } = response.data
        this.fList = [
          {
            uid: file.uid,
            name: fileOriginalName,
            path: filePath,
            status: 'done',
          },
        ]
        this.$message.success('成功')
      } else {
        this.fList = [...data.fileList].slice(-1)
      }
    },
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }
          try {
            const file = this.fList[0] || {}
            values.filePath = file.path
            values.fileOriginalName = file.name
            const { message } = await add({
              attach: this.attach,
              ...values,
              fileType: '4',
              id: this.id,
            })
            this.visible = false
            this.fileList = {}
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 点击编辑
    handleEdit(obj) {
      const { fileName, id, remark, fileOriginalName, filePath } = obj
      if (fileOriginalName === '' || filePath === '') {
        this.fList = []
      } else {
        this.fList = [
          {
            uid: id + '',
            name: fileOriginalName,
            path: filePath,
            status: 'done',
          },
        ]
      }
      this.visible = true
      this.modalTitle = '编辑'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          fileName,
          remark,
          filePath,
        })
        this.id = id
      }, 20)
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
  },
}
</script>
